import React, { useState, useEffect } from "react";
import {
  Box,
  CircularProgress,
  Modal,
  Typography,
  useTheme,
} from "@mui/material";

interface ICommonLoaderProps {
  isVisible: boolean;
}

const CommonLoader: React.FC<ICommonLoaderProps> = ({ isVisible }) => {
  const [dots, setDots] = useState("");
  const theme = useTheme();

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => (prevDots.length < 3 ? prevDots + "." : ""));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <Modal
      open={isVisible}
      aria-labelledby="loader-modal"
      aria-describedby="loader-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: 24,
          p: 4,
          height: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress
          sx={{ color: theme.palette.primary.main, alignSelf: "center", verticalAlign: "true" }}
        />
        {/* <Typography
          id="loader-modal-description"
          sx={{ mt: 2, color: "#39B54A" }}
        >
          {`Loading${dots}`}
        </Typography> */}
      </Box>
    </Modal>
  );
};

export default CommonLoader;
